<div class = "body">
    
    <div class = "afiliado" *ngIf = "rol == 'ROLE_ADMINISTRADOR'">

        <div class = "container" style = "height:50px"> </div>
        
        <div class = "container"> 
                        
            <div class = "row">
            
                <div class = "col-lg-9"> </div>
                        
                <div class = "col-lg-3"> 
                    
                    <button class = "btn btn-success float-right" (click) = "crearCargaMasiva()" > 
                    
                        <i class = "fa fa-plus"></i> Crear Carga Masiva 
                    
                    </button> 
                    
                </div>
            
            </div>

        </div>

        <div class = "container" style = "height:50px"> </div>

        <div class = "container" id = "tabla" style = "background-color: white; padding-top: 50px; padding-bottom:50px">

            <div class = "row">

                <div class = "col-lg-6"> <h1> Registros de Cargas Masivas </h1> </div>

                <div class = "col-lg-3"> <button class = "btn btn-primary" (click) = "loadData()" > 
                    
                    <i class="fas fa-sync"></i> Recargar Listado
                 
                </button>  </div>

                <div class = "col-lg-2"> <h3> Cantidad de Registros </h3> </div>

                <div class = "col-lg-1">

                    <select class = "form-control" (change) = "cambiaCantidadRegistros()" [(ngModel)] = "config.itemsPerPage">
          
                        <option value = "10">10</option>
                        <option value = "20">20</option> 
                        <option value = "30">30</option>
                        <option value = "50">50</option>
                        <option value = "100">100</option>
                         
                    </select> </div>

            </div> <hr/> <br/> 

            <div class = "row">

                <div class = "col-lg-2"> <h3> Fecha de Carga: </h3> </div>
                                
                <div class = "col-lg-3">

                    <input name = "fecha" type = "date" class = "form-control" [(ngModel)] = "buscador.fecha" />  
                
                </div>
                
                <div class = "col-lg-2"> <h3> Tipo de Carga: </h3> </div>
                                
                <div class = "col-lg-3">

                    <input name = "tipoCarga" class = "form-control" #tipoCarga = "ngModel" 
                    [(ngModel)] = "buscador.tipoCarga" placeholder = "Ingrese el tipo de Carga" />  
                
                </div>
                
                <div class = "col-lg-2"> <button class = "btn btn-info" (click) = "buscar()"> 

                    <i class = "fa fa-search"></i> Buscar </button> 
            
                </div>

            </div> <br/> <br/> 

            <div class = "table-responsive">

                <table class = "table">
                
                    <thead style = "background-color: #0f69b4;color:white;">
                    
                        <tr>
                            <th scope = "col"> Fecha de Carga </th>

                            <th scope = "col"> Tipo de Carga </th>

                            <th scope = "col"> Estado </th>

                            <th scope = "col"> Detalle </th>
                            
                            <th scope = "col"> Reversar Carga </th>                            
                        </tr>

                    </thead>
                    
                    <tbody>

                        <tr [class] = "i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor = "let registro of registrosFinales | paginate: config; let i = index">

                            <td> {{registro.fecha}} </td>

                            <td> {{registro.tipo}} </td>
                            
                            <td> {{registro.estado}} </td>
                            
                            <td> <button class = "btn btn-info" (click) = "verArchivoCarga(registro.id)" style = "width:130px"> 
                                    
                                <i class = "fa fa-pen"> </i> Ver Archivo 
                                
                            </button> </td>

                            <td> <button class = "btn btn-danger" (click) = "reversarCarga(registro.id, registro.tipo)" style = "width:120px"> 
                                    
                                <i class = "fa fa-pen"> </i> Reversar 
                                
                            </button> </td>
                        
                        </tr>
                    
                    </tbody>
                
                </table> <br/>

                <pagination-controls style = "text-align: center" previousLabel = "Anterior" nextLabel = "Siguiente" 
                (pageChange) = "pageChanged($event)" autoHide = "true"> </pagination-controls>
                            
            </div>

        </div>
        
        <div class = "container" style = "height:100px"> </div>
    
    </div>

</div>